import React from "react";
import "./header.scss";
/* import Logo_mincomercio from "../../../assets/icons/LogoPresidenciaComercio.svg";
import img_govco from "../../../assets/icons/img-govco.svg"; */
import logo_sic from "../../../assets/icons/logo-sic-footer.png";

export default function Header() {
  return (
    <header className="bodygovcobase">
      <div className="govcobaseheader">
        <div className="govcobaseheader__container">
          <div className="govcobaseheader_container_maxwith">
            <a
              className="govcobaseheader_container_brand"
              href="https://www.gov.co"
              target="_blank"
              rel="noreferrer"
            >
              <img
                className="govcobaseheader_containerbrand_img"
                src="https://sedeelectronica.sic.gov.co/themes/custom/sictheme/logogovco.webp"
                alt="Logo Gov.co"
              />
            </a>
            <a
              className="govcobaseheader_container_link"
              href="https://www.gov.co"
              target="_blank"
              rel="noreferrer"
            >
              Ir a GovCo
            </a>
          </div>
        </div>
        <div className="govcobaseheader__logosbar">
          <div className="govcobaseheader_logosbar_maxwith">
            <div className="govcobaseheader_logosbar_superintendencia">
              <a href="https://www.sic.gov.co/" rel="home">
                <img
                  className="govcobaseheader_logosbar_superintendencia-img"
                  src="https://stgsicstatic.z13.web.core.windows.net/src/Logos-SIC/Logo_SIC_Horizontal.svg"
                  alt="Logo superintendencia"
                  width="250"
                />
              </a>
            </div>
            <div className="govcobaseheader_logosbar_title">
              <h3 className="govcobaseheader_logosbartitle_texto">
              </h3>
            </div>
            <div className="govcobaseheader_logosbar_presidencia">
              <a href="https://petro.presidencia.gov.co/" rel="home">
                <img
                  className="govcobaseheader_logosbarpresidencia_img"
                  src="https://stgsicstatic.z13.web.core.windows.net/src/Logos-Gobierno/Logo_Comercio_Horizontal.png"
                  alt="Logo presidencia"
                  width="250"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
